// src/features/tower/storeReadiness/components/ReadinessTile.tsx

import React from "react";
import type { ReadinessTile as TileType } from "../types";

const STATUS_STYLE: Record<TileType["status"], { bg: string; fg: string; label: string }> = {
  NOT_STARTED: { bg: "#FEE2E2", fg: "#991B1B", label: "Not started" },
  IN_PROGRESS: { bg: "#FEF3C7", fg: "#92400E", label: "In progress" },
  AWAITING_VERIFICATION: { bg: "#DBEAFE", fg: "#1E40AF", label: "Awaiting verification" },
  COMPLETE: { bg: "#DCFCE7", fg: "#166534", label: "Complete" },
  BLOCKED: { bg: "#FEE2E2", fg: "#991B1B", label: "Blocked" },
  EXCEPTED: { bg: "#F3F4F6", fg: "#4B5563", label: "Excepted" },
  REOPENED: { bg: "#FEF3C7", fg: "#92400E", label: "Reopened" },
};

export function ReadinessTile({ tile, onClick }: { tile: TileType; onClick: () => void }) {
  const style = STATUS_STYLE[tile.status];

  return (
    <button
      onClick={onClick}
      style={{
        textAlign: "left",
        border: "1px solid var(--ct-line)",
        borderRadius: 8,
        padding: "10px 12px",
        background: "var(--ct-surface)",
        cursor: "pointer",
        fontFamily: "inherit",
      }}
    >
      <div
        style={{
          display: "inline-block",
          fontSize: 10,
          fontWeight: 700,
          padding: "2px 8px",
          borderRadius: 5,
          background: style.bg,
          color: style.fg,
          marginBottom: 6,
        }}
      >
        {style.label}
      </div>

      <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ct-ink)", marginBottom: 2 }}>
        {tile.taskName}
      </div>

      <div style={{ fontSize: 11, color: "var(--ct-ink-3)" }}>
        Target: {tile.targetDurationMinutes} min
        {tile.criticality === "CRITICAL" && (
          <span style={{ color: "#991B1B", fontWeight: 600 }}> · Critical</span>
        )}
      </div>
    </button>
  );
}
